import request from '@/helpers/request'
import router from '@/router'
import Vue from 'vue'
import moment from 'moment'
import snack from '@/helpers/snack'
import { getUnitSettingsByAlias } from '@/helpers/getUnitSettingsByAlias'
import fullName from '@/helpers/full_name'

export default {
  APPEND_UNITS: ({ commit, state }, payload = {}) => {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.units.all}`,
      {
        params: payload.params,
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const units = response.data.data
        commit('appendUnits', units.items)
        commit('setLoad', false)
      } else {
        // TODO: Show error dialog
      }
    })
  },
  GET_UNITS: ({ commit, state }, payload = {}) => {
    let params = {
      sortedBy: 'asc',
      orderBy: 'name',
    }

    Object.keys(payload).forEach(key => {
      params[key] = payload[key]
    })

    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.units.all}`,
      {
        params: params,
      },
      true,
    ).then(response => {
      let units = response.data.data.items
      if (payload.resultUnitTypes) {
        units = _.filter(units, unit => payload.resultUnitTypes.includes(unit.type))
      }
      for (let i = 0; i < units.length; i++) {
        units[i].title = units[i].name
      }
      commit('setUnits', units)
    })
  },

  async FETCH_UNITS(context, payload) {
    try {
      const response = await request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.units.all}`,
        payload,
        true,
      )
      return response.data.data.items
    } catch (e) {
      snack.add(Vue.config.localization.ru.loadingError)
      return []
    }
  },

  GET_UNIT({ commit, state }, unitID) {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.units.one.replace('$unit_id', unitID)}`,
      {},
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const unit = response.data.data
        Object.assign(unit, { neighbours: [] })
        commit('setUnit', unit)
        commit('setTitle', state.unit.name)
        commit('setLoad', false)
      } else {
        // TODO: Show error dialog
      }
    })
  },
  GET_UNIT_WINDOW: ({ commit, state, rootGetters }, params) => {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.units.windows.replace('$unit_id', params.unit_id)}`,
      {
        params,
        headers: {
          'X-Timezone': rootGetters.timezone ? rootGetters.timezone : 'Europe/Moscow',
        },
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const windows = _.map(response.data.data, window => {
          try {
            const windowId = window.id
            if (_.some(window.booking.services, service => service.pivot.window_id !== windowId)) {
              const startOne = moment(
                _.find(window.booking.services, service => service.pivot.window_id === window.id).pivot.begin_at,
              )
              const startTwo = moment(
                _.find(window.booking.services, service => service.pivot.window_id !== window.id).pivot.begin_at,
              )
              const diff = startTwo.diff(startOne, 'seconds')
              window.booking.parallel = diff >= -900 && diff <= 900
            }
          } catch (e) {}
          return window
        })
        commit('setUnitWindows', windows)
      }
    })
  },
  GET_UNIT_SCHEDULES: ({ commit, state }, { unitId, params = {} }) => {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.units.schedules.replace('$unit_id', unitId)}`,
      {
        params,
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const windows = response.data.data
        commit('setUnitSchedules', windows)
      } else {
      }
    })
  },
  GET_NEW_UNIT_DATA: ({ commit, state }) => {
    commit('setLoad', true)

    // Get units
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.units.all}`,
      {
        params: {
          offset: 0,
          limit: 30,
        },
      },
      true,
    )
      .then(response => {
        if (response.data.result === 'success') {
          const units = response.data.data.items
          commit('setUnits', units)
          commit('setLoad', false)

          return request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.cities.all}`, {}, true)
        } else {
          // TODO: Show error dialog
        }
      })
      .then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('setCities', data.items)

          return request(
            'GET',
            `${Vue.config.server}/${Vue.config.modules.crm.api.units.all}`,
            {
              params: {
                search: `location_id:${state.unit.location_id};type:0`,
                // searchJoin: 'and',
                searchFields: 'location_id:=;type:=',
              },
            },
            true,
          )
        } else {
          // TODO: Show error dialog
        }
      })
      .then(response => {
        if (response.data.result === 'success') {
          const units = response.data.data.items
          commit('setUnitNeighbours', units)
          commit('setLoad', false)
        } else {
          // TODO: Show error dialog
        }
      })
  },
  GET_UNIT_WITH_UNITS({ commit, state }, unitID) {
    commit('setLoad', true)

    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.units.one.replace('$unit_id', unitID)}`,
      {
        params: {
          with: 'neighbours;unitSettings.type',
        },
      },
      true,
    )
      .then(response => {
        if (response.data.result === 'success') {
          const unit = response.data.data
          if (unit.promo_goods || unit.promo_services) {
            unit.unitWithoutSettingsPilki = true
          } else {
            unit.unitWithoutSettingsPilki = false
          }
          commit('setUnit', unit)
          commit('setTitle', unit.name)

          // Get units
          return request(
            'GET',
            `${Vue.config.server}/${Vue.config.modules.crm.api.units.all}`,
            {
              params: {
                offset: 0,
                limit: 30,
              },
            },
            true,
          )
        } else {
          // TODO: Show error dialog
        }
      })
      .then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('setUnits', data.items)
          commit('setUnitFilters', data.filters)

          return request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.cities.all}`, {}, true)
        } else {
          // TODO: Show error dialog
        }
      })
      .then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('setCities', data.items)

          return request(
            'GET',
            `${Vue.config.server}/${Vue.config.modules.crm.api.units.all}`,
            {
              params: {
                search: `location_id:${state.unit.location_id};type:0;closed:0;`,
                searchJoin: 'and',
                searchFields: 'location_id:=;type:=;closed:=;',
              },
            },
            true,
          )
        } else {
          // TODO: Show error dialog
        }
      })
      .then(response => {
        if (response.data.result === 'success') {
          const units = response.data.data.items
          units.sort(function (a, b) {
            const nameA = a.name.toLowerCase()
            const nameB = b.name.toLowerCase()
            if (nameA < nameB) return -1
            if (nameA > nameB) return 1
            return 0
          })

          _.remove(units, function (unit) {
            return unit.id === unitID
          })

          commit('setUnitNeighbours', units)
          commit('setLoad', false)
        } else {
          // TODO: Show error dialog
        }
      })
  },
  async UPDATE_UNIT({ commit, state, rootState }, { callback }) {
    commit('setLoad', true)
    const neighbours = _.map(state.unit.neighbours, 'id')
    try {
      const promises = []
      promises.push(
        request(
          'PUT',
          `${Vue.config.server}/${Vue.config.modules.crm.api.units.one.replace('$unit_id', state.unit.id)}`,
          {
            address: state.unit.address,
            info: state.unit.info,
            address_short: state.unit.address_short,
            closed: state.unit.closed,
            name: state.unit.name,
            name_show: state.unit.name_show,
            location_id: state.unit.location_id,
            // BEGIN Тариф хардкод за час
            location_type: 'App\\Models\\City',
            // END Тариф хардкод за час
            company_id: state.unit.company_id,
            neighbours: neighbours,
            type: state.unit.type,
            stores: state.unit.stores,
            is_price_list_enabled: state.unit.is_price_list_enabled,
            window_ratio: state.unit.window_ratio,
            window_ratio2: state.unit.window_ratio2,
            window_cancel_min: state.unit.window_cancel_min,
            window_split_indent: state.unit.window_split_indent,
            window_split_min: state.unit.window_split_min,
            no_window_quantum_size: state.unit.no_window_quantum_size,
            latitude: state.unit.latitude,
            longitude: state.unit.longitude,
            timezone: state.unit.timezone,
            is_franchise: state.unit.is_franchise,
            promo_services: state.unit.unitWithoutSettingsPilki
              ? state.unit.promo_services
                ? state.unit.promo_services
                : []
              : null,
            promo_services_array: state.unit.unitWithoutSettingsPilki ? state.unit.promo_services_array : null,
            promo_goods: state.unit.unitWithoutSettingsPilki
              ? state.unit.promo_goods
                ? state.unit.promo_goods
                : []
              : null,
            promo_goods_array: state.unit.unitWithoutSettingsPilki ? state.unit.promo_goods_array : null,
            default_safe_id: state.unit.default_safe_id,
            default_cash_register_id: state.unit.default_cash_register_id,
            settings: state.unit.settings || {},
            is_in_analytics: state.unit.is_in_analytics,
            is_tablet_enabled: state.unit.is_tablet_enabled,
            waiting_list: state.unit.waiting_list,
            in_aggregator: state.unit.in_aggregator ? 1 : 0,
            no_window_period: state.unit.no_window_period,
            hybrid_schedule: state.unit.hybrid_schedule,
            use_auth: state.unit.use_auth ? 1 : 0,
            schedule: state.unit.schedule,
            order: state.unit.order,
            city_district: state.unit.city_district,
            metro: state.unit.metro,
            unit_settings: {
              isAvatarNeeded: state.unit.isAvatarNeeded ?? getUnitSettingsByAlias(state.unit, 'isAvatarNeeded'),
              isPortfolioNeeded:
                state.unit.isPortfolioNeeded ?? getUnitSettingsByAlias(state.unit, 'isPortfolioNeeded'),
            },
          },
          true,
        ),
      )
      if (state.unit.addedImage) {
        const formData = new FormData()
        formData.append('image', state.unit.addedImage)
        promises.push(
          request(
            'POST',
            `${Vue.config.server}/${Vue.config.modules.crm.api.units.images.replace('$unit_id', state.unit.id)}`,
            {
              data: formData,
              headers: {
                'Content-Type': 'multipart/form-data',
                'Content-Disposition': 'x-www-form-urlencoded',
              },
            },
            true,
          ),
        )
      }
      const [unitResponse] = await Promise.all(promises)
      const unit = unitResponse.data.data
      unit.unitWithoutSettingsPilki = state.unit.unitWithoutSettingsPilki
      commit('setUnit', unit)
      commit('changeUnit', { key: state.unit.id, value: state.unit })
      commit('setTitle', state.unit.name)
      if (callback) callback(state.unit)
      snack.add(Vue.config.localization.ru.savedMessage, 'primary')
    } catch (e) {
      if (e.response?.data && Object.keys(e.response.data).length) {
        snack.add(Object.values(e.response.data).join(', '), 'error')
      } else {
        snack.add(Vue.config.localization.ru.errorSavingMessage, 'error')
      }
    } finally {
      commit('setLoad', false)
    }
  },
  async CREATE_UNIT({ commit, state, rootState }) {
    commit('setLoad', true)
    const neighbours = _.map(state.unit.neighbours, 'id')
    try {
      const response = await request(
        'POST',
        `${Vue.config.server}/${Vue.config.modules.crm.api.units.all}`,
        {
          address: state.unit.address,
          address_short: state.unit.address_short,
          name: state.unit.name,
          location_id: state.unit.location_id,
          // BEGIN Тариф хардкод за час
          location_type: 'App\\Models\\City',
          // END Тариф хардкод за час
          company_id: state.unit.company_id,
          window_ratio: state.unit.window_ratio,
          window_ratio2: state.unit.window_ratio2,
          window_cancel_min: state.unit.window_cancel_min,
          window_split_indent: state.unit.window_split_indent,
          window_split_min: state.unit.window_split_min,
          no_window_quantum_size: state.unit.no_window_quantum_size,
          is_price_list_enabled: state.unit.is_price_list_enabled,
          latitude: 0,
          longitude: 0,
          neighbours: neighbours,
          type: state.unit.type,
          timezone: state.unit.timezone,
          default_safe_id: state.unit.default_safe_id,
          settings: state.unit.settings || {},
          default_cash_register_id: state.unit.default_cash_register_id,
          waiting_list: state.unit.waiting_list,
          schedule: state.unit.schedule,
          order: state.unit.order,
          city_district: state.unit.city_district,
          metro: state.unit.metro,
          is_franchise: state.unit.is_franchise,
        },
        true,
      )
      const data = response.data.data
      if (state.unit.addedImage) {
        const formData = new FormData()
        formData.append('image', state.unit.addedImage)
        await request(
          'POST',
          `${Vue.config.server}/${Vue.config.modules.crm.api.units.images.replace('$unit_id', data.id)}`,
          {
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data',
              'Content-Disposition': 'x-www-form-urlencoded',
            },
          },
          true,
        )
      }
      commit('setUnitField', { key: 'id', value: data.id })
      commit('setTitle', state.unit.name)
      commit('unshiftUnits', { ...state.unit })
      router.push({ path: Vue.config.modules.crm.route.units.one.replace('$unit_id', data.id) })
      snack.add(Vue.config.localization.ru.savedMessage, 'primary')
    } catch (e) {
      snack.add(Vue.config.localization.ru.errorSavingMessage, 'error')
    } finally {
      commit('setLoad', false)
    }
  },
  DELETE_UNIT: ({ commit, state }) => {
    commit('setLoad', true)
    request(
      'DELETE',
      `${Vue.config.server}/${Vue.config.modules.crm.api.units.one.replace('$unit_id', state.unit.id)}`,
      {},
      true,
    ).then(
      response => {
        if (response.data.result === 'success') {
          commit('deleteUnit', state.unit.id)
          const unitsLength = state.units.length

          if (unitsLength != 0) {
            commit('setUnit', state.units[0])
            commit('setUnitField', { key: 'id', value: state.units[0].id })
            commit('setTitle', state.units[0].name)

            commit('setUnitErrors', null)
            commit('setLoad', false)

            router.push({ path: Vue.config.modules.crm.route.units.one.replace('$unit_id', 1) })

            Vue.notify({
              group: 'hasBottomNavigation',
              title: '',
              type: 'success',
              text: Vue.config.localization.ru.deleteMessage,
            })
          } else {
            router.push({ path: Vue.config.modules.crm.route.units.all })
          }
        } else {
          commit('setServiceErrors', null)
          commit('setLoad', false)

          Vue.notify({
            group: 'hasBottomNavigation',
            title: '',
            type: 'error',
            text: Vue.config.localization.ru.notFoundMessage,
          })
          // TODO: Show error dialog
        }
      },
      e => {
        commit('setLoad', false)
      },
    )
  },
  GET_UNIT_NEIGHBOURS: ({ commit, state }, payload = {}) => {
    commit('setUnitNeighboursLoad', true)

    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.units.all}`,
      payload.data ? payload.data : {},
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const units = response.data.data.items

        units.sort(function (a, b) {
          const nameA = a.name.toLowerCase()
          const nameB = b.name.toLowerCase()
          if (nameA < nameB) return -1
          if (nameA > nameB) return 1
          return 0
        })

        if (payload.removeByID !== undefined) {
          _.remove(units, function (unit) {
            return unit.id === payload.removeByID
          })
        }

        commit('setUnitNeighbours', units)
        commit('setUnitNeighboursLoad', false)
      } else {
        // TODO: Show error dialog
      }
    })
  },
  GET_UNIT_TYPES: ({ commit, state }, payload) => {
    if (payload.showPreloader) {
      commit('setLoad', true)
    }

    request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.units.types}`, payload.data, true).then(
      response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('setUnitTypes', data)
          commit('setUnitTypesFilter', data)
        } else {
          // TODO: Show error dialog
        }
      },
    )
  },
  SEARCH_STORES: ({ commit, state }, params) => {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.stores.all}`,
      {
        params: {
          search: `title:${params};unit.name:${params}`,
          searchFields: 'title:like;unit.name:like',
          with: 'unit',
          limit: 100,
          offset: 0,
        },
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        return _.map(response.data.data.items, store => {
          const names = []
          if (!!store && !!store.unit && !!store.unit.name) {
            names.push(store.unit.name.trim())
          }
          if (!!store && !!store.title) {
            names.push(store.title.trim())
          }
          store.name = names.join(' ')
          return store
        })
      } else {
        throw response
      }
    })
  },

  async GET_UNITS_FOR_AUTOCOMPLETE(context, params) {
    try {
      const response = await request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.units.all}`,
        {
          params: {
            search: `name:${params}`,
            searchFields: 'name',
            searchJoin: 'and',
            limit: 100,
            offset: 0,
          },
        },
        true,
      )
      return response.data.data.items
    } catch (e) {
      snack.add(Vue.config.localization.ru.loadingError)
      return []
    }
  },
}
